export default __webpack_public_path__ + "f7307680c7fe85959f3ecf122493ea7d.woff2";